"use client";
import { ThemeProvider as StyledThemeProvider } from "styled-components";

import { theme } from "./themes";

import type { JSX } from "react";
import { ThemedBody } from "./styles";

export const ThemeProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <StyledThemeProvider theme={theme}>
    <ThemedBody />
    {children}
  </StyledThemeProvider>
);
